import Modal from 'react-modal';
import PropTypes from 'prop-types';
import "../../../styles/AdminPage.css";
import React , {useEffect, useState} from 'react';
import { createShirtSize, updateShirtSize } from '../../../api/admin/AdminSettingsAPI';
import AdminSettingsEditModal from './AdminSettingsEditModal';
import DropdownModalContent from './EditDropdownModal';
import toast from 'react-hot-toast';

Modal.setAppElement('#root');

const EditShirtSizeModal = ({ isOpen, onClose, isAdding, item, setItems }) => {    
    const [dropdownValue, setDropdownValue] = useState("");
    const [position, setPosition] = useState(null);

    useEffect(() => {
        if (!isAdding && item) {
            setDropdownValue(item.dropdownValue);
            setPosition(item.position);
        }
    }, [isAdding, item]);

    const modalTitle = isAdding ? "Add Shirt Size" : "Edit Shirt Size";

    const handleConfirm = async () => {
        let data;

        if (isAdding) {
            data = {
                dropdownValue,
                position
            };

            try {
                toast.loading("Creating Shirt Size...");
                const response = await createShirtSize(data);
                setTimeout(async () => {
                    if (response.ok) {
                        toast.dismiss();
                        try {
                            const newData = await response.json();
                            toast.success("Shirt Size created!");
                            setItems((prev) => [...(prev ?? []), newData]);
                            onClose();
                        } catch (jsonError) {
                            console.error("Error parsing JSON:", jsonError);
                            toast.error("Error parsing server response.");
                        }
                    } else {
                        toast.dismiss();
                        console.log("Error creating Shirt Size. Status:", response.status);
                        toast.error("Shirt Size failed to create. Status: " + response.status);
                    }
                    
                }, 500);
            } catch (error) {
                toast.dismiss();
                console.error("Error submitting Swag Item:", error);
                alert("Something went wrong. Please check your connection and try again.");

            }
        } else {
            data = {
                id: item.id,
                dropdownValue: dropdownValue,
                position: position
            };
            try {
                toast.loading("Updaing Shirt Size...");
                const response = await updateShirtSize(data);
                setTimeout(async () => {
                        if (response.ok) {
                            toast.dismiss();
                            try {
                                toast.success("Shirt Size updated!");
                                setItems((prev) => (prev ?? []).map(s => s.id === item.id ? data : s));
                                onClose();
                            } catch (jsonError) {
                                console.error("Error parsing JSON:", jsonError);
                                toast.error("Error parsing server response.");
                            }
                        } else {
                            toast.dismiss();
                            console.log("Error updating Shirt Size. Status:", response.status);
                            toast.error("Shirt Size failed to create. Status: " + response.status);
                        }
                }, 500);
            } catch (error) {
                toast.dismiss();
                console.error("Error submitting Shirt Size:", error);
                alert("Something went wrong. Please check your connection and try again.");
            }
        }
    };

    const content = (
        <DropdownModalContent 
            dropdownValue={dropdownValue}
            setDropdownValue={setDropdownValue}
            position={position}
            setPosition={setPosition}
        />
    )

    return (
        <AdminSettingsEditModal
            modalTitle={modalTitle}
            content={content}
            isOpen={isOpen}
            onClose={onClose}
            handleConfirm={handleConfirm}
        />
    );
};

EditShirtSizeModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default EditShirtSizeModal;